import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import LockIcon from '@mui/icons-material/Lock'
import { t } from '@lingui/macro'

export function AccessDenied({ title, description, children }: { title?: string; description?: string; children?: React.ReactNode }) {
  return (
    <Stack data-testid="access-denied" alignItems="center" justifyContent="center" spacing={1} width="100%" height="100%">
      <LockIcon fontSize="large" />
      <Typography variant="h1" fontSize="30px" fontWeight={700}>
        {title ?? t`Permission denied`}
      </Typography>
      <Typography variant="caption" fontSize="16px">
        {description ?? t`Access to this page is restricted`}
      </Typography>
      {children}
    </Stack>
  )
}

export default AccessDenied
